import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormFieldOneInput from './fields/FormFieldOneInput';
import { getDefaultWidgetDisclaimer } from '../../utils';

const WidgetDisclaimerForm = ({ errorMessage, setFieldValue }) => {
	const [key, setKey] = useState(0);

	const forceRefresh = () => {
		setKey(key + 1);
	};

	return (
		<FormFieldOneInput
			errorMessage={errorMessage}
			control="editor"
			fieldName="widget_disclaimer"
			placeholder="Widget disclaimer"
			key={key}
			defaultFieldValue={getDefaultWidgetDisclaimer({})}
			setFieldValue={setFieldValue}
			forceRefresh={forceRefresh}
		/>
	);
};

WidgetDisclaimerForm.propTypes = {
	errorMessage: PropTypes.string,
	setFieldValue: PropTypes.func,
};

export default WidgetDisclaimerForm;
